import { render, staticRenderFns } from "./TheMenuSettings.vue?vue&type=template&id=ef5d9a86&"
import script from "./TheMenuSettings.vue?vue&type=script&lang=js&"
export * from "./TheMenuSettings.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports